import { toast } from '../Toast';
import {
  NOTIFY_VARIANTS,
  type NotifyShowOptions,
  type NotifyVariant,
} from './config';
import NotifyToast from './NotifyToast';

const show = (
  variant: NotifyVariant,
  message: string,
  options?: NotifyShowOptions
) => {
  const timeoutMs =
    options?.timeoutMs === undefined
      ? NOTIFY_VARIANTS[variant].timeoutMs
      : options.timeoutMs;
  toast.show(
    <NotifyToast
      variant={variant}
      message={message}
      timeoutMs={timeoutMs}
      action={options?.action}
    />,
    { timeoutMs, intent: variant }
  );
};

export const notify = {
  success: (message: string, options?: NotifyShowOptions) =>
    show('success', message, options),
  error: (message: string, options?: NotifyShowOptions) =>
    show('error', message, options),
  warning: (message: string, options?: NotifyShowOptions) =>
    show('warning', message, options),
  info: (message: string, options?: NotifyShowOptions) =>
    show('info', message, options),
};
